import defaultCcLogo from '../../../assets/icons/payment/default_cc_logo.png';
import amexLogo from '../../../assets/icons/payment/amex_logo.png';
import discoverLogo from '../../../assets/icons/payment/discover_logo.png';
import mastercardLogo from '../../../assets/icons/payment/mastercard_logo.png';
import visaLogo from '../../../assets/icons/payment/visa_logo.png';

const LOGOS_BY_BANK_NAME = {
  amex: amexLogo,
  visa: visaLogo,
  mastercard: mastercardLogo,
  discover: discoverLogo,
  mc: mastercardLogo
};

export function resolveCreditCardLogo({ bankName, bankNameShort, cardBackgroundURL }) {
  if (cardBackgroundURL) {
    return cardBackgroundURL;
  }

  const keys = [bankName, bankNameShort]
    .map((value) => String(value ?? '').trim().toLowerCase())
    .filter(Boolean);

  for (const key of keys) {
    const logo = LOGOS_BY_BANK_NAME[key];
    if (logo) {
      return logo;
    }
  }

  return defaultCcLogo;
}
